/**
 * 东财wap分享
 */

var emshare = {
    /**
     * 初始化
     * shareobj = {
        url: '分享链接',
        title: '分享标题',
        des: '分享简介',
        img: '分享图片链接',
        from: '来源'
    }
     */
    init: function(shareobj){
        this.shareobj = shareobj;
        if(this.shareobj.img){

        }
        else{
            this.shareobj.img = 'http://wap.eastmoney.com/weixin-share.png';
        }

        var ua = navigator.userAgent.toLowerCase();

        if(ua.indexOf('mqqbrowser') >= 0){
            this.isqqbrowser = true;
        }
        else{
            this.isqqbrowser = false;
        }

        if(ua.indexOf('ucbrowser') >= 0){
            this.isucbrowser = true;
        }
        else{
            this.isucbrowser = false;
        } 

        if(ua.indexOf('micromessenger') >= 0){
            this.iswxbrowser = true;
        }
        else{
            this.iswxbrowser = false;
        }
    },

    /**
     * 加载qq浏览器分享js
     */
    loadQQJs: function(succ){

        if(typeof browser != 'undefined' && typeof browser.app != 'undefined'){
            succ();
            return false;
        }

        var qqjs = document.createElement("script");  
        qqjs.src = 'http://jsapi.qq.com/get?api=app.share';
        document.getElementsByTagName("body")[0].appendChild(qqjs);
        qqjs.onload = function(){
            succ();
        }
    },

    /**
     * 微信朋友圈
     */
    wxcircle: function(){
        
        if(!this.isqqbrowser && !this.isucbrowser){
            this.browserFail();
            return false;
        }
        if(this.isqqbrowser){
            this.loadQQJs(function(){
                browser.app.share({
                    url: this.shareobj.url,
                    title: this.shareobj.title,
                    description: this.shareobj.des,
                    img_url: this.shareobj.img,
                    img_title: '',
                    to_app: 8,
                    cus_txt: '请输入此时此刻想要分享的内容'
                });
            }.bind(this));
            return false;
        }

        if(this.isucbrowser){
            if(typeof ucweb == 'object'){
                ucweb.startRequest("shell.page_share", [this.shareobj.title, this.shareobj.des, this.shareobj.url, 'WechatTimeline', "", "@", '']);
                return false;
            }
            if(typeof ucbrowser == 'object'){
                ucbrowser.web_share(this.shareobj.title, this.shareobj.des, this.shareobj.url, 'kWeixinFriend', "", "@", '');
                return false;
            }
            this.browserFail();
            return false;
        }
        return false;
    },

    /**
     * 微信好友
     */
    wzfriend: function(){
        
        if(!this.isqqbrowser && !this.isucbrowser){
            this.browserFail();
            return false;
        }
        if(this.isqqbrowser){
            this.loadQQJs(function(){
                browser.app.share({
                    url: this.shareobj.url,
                    title: this.shareobj.title,
                    description: this.shareobj.des,
                    img_url: this.shareobj.img,
                    img_title: '',
                    to_app: 1,
                    cus_txt: '请输入此时此刻想要分享的内容'
                });
            }.bind(this));
            return false;
        }

        if(this.isucbrowser){
            if(typeof ucweb == 'object'){
                ucweb.startRequest("shell.page_share", [this.shareobj.title, this.shareobj.des, this.shareobj.url, 'WechatFriends', "", "@", '']);
                return false;
            }
            if(typeof ucbrowser == 'object'){
                ucbrowser.web_share(this.shareobj.title, this.shareobj.des, this.shareobj.url, 'kWeixin', "", "@", '');
                return false;
            }
            this.browserFail();
            return false;
        }
        return false;
    },

    /**
     * 微博
     */
    weibo: function(){
        var url = 'http://service.weibo.com/share/mobile.php?url=' + encodeURI(this.shareobj.url) + '&appkey=3050999700&title=' + encodeURI(this.shareobj.title) + '&pic=' + encodeURI(this.shareobj.img) + '&ralateUid=1801487174&source=' + encodeURI(this.shareobj.from) + '&sourceUrl=' + encodeURI('http://wap.eastmoney.com');

        self.location = url;
        return false;
    },

    /**
     * qq空间
     */
    qqzoom: function(){
        
        var url = 'http://qzs.qzone.qq.com/open/connect/widget/mobile/qzshare/index.html?url=' + encodeURI(this.shareobj.url) + '&appkey=801004939&title=' + encodeURI(this.shareobj.title) + '&desc=' + encodeURI(this.shareobj.des) + '&imageUrl=' + encodeURI(this.shareobj.img) + '&site=' + encodeURI('http://wap.eastmoney.com');

        self.location = url;
        return false;
    },

    /**
     * qq好友
     */
    qqfriend: function(){

        if(!this.isqqbrowser && !this.isucbrowser){
            this.browserFail();
            return false;
        }
        if(this.isqqbrowser){
            this.loadQQJs(function(){
                browser.app.share({
                    url: this.shareobj.url,
                    title: this.shareobj.title,
                    description: this.shareobj.des,
                    img_url: this.shareobj.img,
                    img_title: '',
                    to_app: 4,
                    cus_txt: '请输入此时此刻想要分享的内容'
                });
            }.bind(this));
            return false;
        }

        if(this.isucbrowser){
            if(typeof ucweb == 'object'){
                ucweb.startRequest("shell.page_share", [this.shareobj.title, this.shareobj.des, this.shareobj.url, 'QQ', "", "@", '']);
                return false;
            }
            if(typeof ucbrowser == 'object'){
                ucbrowser.web_share(this.shareobj.title, this.shareobj.des, this.shareobj.url, 'kQQ', "", "@", '');
                return false;
            }
            this.browserFail();
            return false;
        }
        return false;
    },

    browserFail: function(){
        alert('当前浏览器不支持此操作！');
    }
}

module.exports = emshare;


//////////////////
// WEBPACK FOOTER
// ./dev/modules/share/emshare.js
// module id = 16
// module chunks = 11 20